export default __webpack_public_path__ + "static/media/FIN.e6682c3f.svg";